import { LABEL_SIZE_MAP } from '../constants';

const partToRemnant = (part, id, colors) => part && id ? {
    ...part,
    id,
    ogPartId: part.id,
    size: LABEL_SIZE_MAP.REMNANT,
    type: 'remnant',
    colors
} : null;

export default {
    partToRemnant
};